<template>
    <div class="container-fluid">
       <div class="row">
            <div class="col-6">
                <!-- //espaço em branco// -->
            </div>
            <div class="col-6">
                <ol style="float: right;" class="breadcrumb ">
                    <a v-show="opcrud > 0" @click.prevent="mtdcancelaredicao()"
                        class="btn btn-info btn-sm button-voltar"><i class="fa fa-arrow-alt-circle-left"></i>
                        Voltar</a>
                    <li style="padding-left: 15px;" class="breadcrumb-item"><router-link to="/">Início</router-link></li>
                    <li class="breadcrumb-item"><a @click.prevent="mtdcancelaredicao()">Zonas</a></li>
                    <li class="breadcrumb-item active">{{ descop.toLocaleLowerCase() }}</li>
                </ol>
            </div>
        </div>

        <div id="pnlista">
            <div class="card mb-3">
                <div class="card-header">
                    <div class="row">
                        <div class="col-lg-12">
                            <a @click.prevent="mtdnovo()" class="btn btn-info">
                                <i class="bi bi-geo-alt"></i> Nova Zona
                            </a>
                        </div>
                    </div>
                </div>
            </div>

              <div class="card mb-3">
                <div class="card-header">
                    <div class="row">
                        <div class="col-lg-2">
                            <div class="form-group">
                                <label for="edtipopesq">Por</label>
                                <select class="form-select form-control" v-model="pfiltro"
                                    aria-label="Default select example">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label for="">pesquisa</label>
                                <input type="text" v-model="pconteudo" class="form-control" id="nome" required="">
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <div class="form-group">
                                <label for="">Limite
                                </label>
                                <select class="form-select form-control" v-model.number="pqtdregistros"
                                    aria-label="Default select example">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                    <option value="500">500</option>
                                    <option value="1000">1000</option>
                                    <option value="99999999">Todos</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-2" style="padding-top: 25px;">
                            <a @click.prevent="mtdexecutapesquisa()" style="width: 100%;" class="btn btn-info">
                                <i class="bi bi-search"></i> Listar
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <EasyDataTable :headers="headers" :items="lstzonas" hide-footer
                        empty-message="Nenhuma zona encontrada"
                        table-class-name="table table-hover text-nowrap table-bordered table-striped">
                        <template #item-acoes="{ id }">
                            <div style="display: flex; justify-content: center;">
                                <a @click="mtdalterar(id)" class="btn btn-sm btn-warning"><i class="bi bi-pencil-square"></i></a>
                                <button style="margin-left: 15px;" class="btn btn-sm btn-danger" @click="mtdexcluir(id)"><i class="bi bi-trash"></i></button>
                            </div>
                        </template>
                    </EasyDataTable>
                </div>
                <div class="card-footer">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <vue-awesome-paginate :total-items="pqtd_total_registros" :items-per-page="pqtdregistros"
                                    :max-pages-shown="2" v-model="pagina_atual"  />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="pncadastro">
            <div class="card">
                <div class="card-body">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-2">
                                <div class="form-group">
                                    <label>Código</label>
                                    <input type="text" v-model="vid" class="form-control" disabled>
                                </div>
                            </div>
                            <div class="col-lg-10">
                                <div class="form-group">
                                    <label>Descrição da Zona</label>
                                    <input type="text" v-model="vdescricao" :disabled="ativadesativa" class="form-control" placeholder="Ex: Área de Entrega Norte">
                                </div>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-12">
                                <label>Defina o Perímetro no Mapa (Clique para criar o raio)</label>
                                <div id="map" style="height: 400px; border-radius: 8px; border: 1px solid #ddd;"></div>
                                <p class="text-muted small">* Clique no mapa para definir o centro e arraste para ajustar ou use o campo abaixo.</p>
                            </div>
                        </div>

                        <div class="row mt-2">
                            <div class="col-lg-4">
                                <label>Raio (metros)</label>
                                <input type="number" v-model="vraio" @input="atualizarMapaPorInput" :disabled="ativadesativa" class="form-control">
                            </div>
                            <div class="col-lg-4">
                                <label>Latitude</label>
                                <input type="text" v-model="vlat" disabled class="form-control">
                            </div>
                            <div class="col-lg-4">
                                <label>Longitude</label>
                                <input type="text" v-model="vlng" disabled class="form-control">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer text-right">
                    <button v-show="opcrud == 1" :disabled="validou" @click.prevent="mtdgravar()" class="btn btn-info">Gravar</button>
                    <button v-show="opcrud == 2" :disabled="validou" @click.prevent="mtdgravar()" class="btn btn-warning">Alterar</button>
                    <button v-show="opcrud == 3" @click.prevent="mtdgravar()" class="btn btn-danger">Excluir</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import util from '../util.js';
import EasyDataTable from 'vue3-easy-data-table';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// SOLUÇÃO PARA O ÍCONE AZUL DESAPARECIDO:
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

import { ref } from "vue";

const onClickHandler = (page) => {
  console.log(page);
};

const pagina_atual = ref(1);


export default {
    name: 'Zonas',
    components: { EasyDataTable },
    data() {
        return {
            opcrud: 0,
            vid: 0,
            vdescricao: '',
            vlat: '',
            vlng: '',
            vraio: 500, // raio padrão 500m

             //paginação
            pqtd_total_registros: 10,
            pagina_atual        : 1,
            pqtdregistros       : 10,
            pqtd_paginas        : 0,


            //filtros
            pfiltro             : 1,
            pconteudo           : '',

            modulo              : 'ZONAS',

           
            
            descop: '',
            ativadesativa: false,
            lstzonas: [],
            headers: [
                { text: 'Ações',     value: 'acoes', width: 80 },
                { text: 'Nome',      value: 'nome', sortable: true },
                { text: 'Raio (m)',  value: 'raio' }
            ],

            // Leaflet Objects
            map: null,
            circle: null,
            marker: null
        }
    },
     methods: {
        mtdinitMap() {
            if (this.map) {
                // Limpeza segura das camadas existentes
                if (this.circle) this.map.removeLayer(this.circle);
                if (this.marker) this.map.removeLayer(this.marker);
                if (this.edgeMarker) this.map.removeLayer(this.edgeMarker);
                
                // Resetamos as variáveis para evitar referências a objetos removidos
                this.circle = null;
                this.marker = null;
                this.edgeMarker = null;
            } else {
                // Inicializa o mapa apenas se não existir
                this.map = L.map('map').setView([-23.5505, -46.6333], 13);

                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '© OpenStreetMap'
                }).addTo(this.map);

                this.map.on('click', (e) => {
                    if (this.ativadesativa) return;
                    this.vlat = e.latlng.lat;
                    this.vlng = e.latlng.lng;
                    this.desenharZona();
                });
            }

            // Se estiver editando (já tem lat/lng), desenha e centraliza
            if (this.vlat && this.vlng) {
                this.desenharZona();
                this.map.setView([this.vlat, this.vlng], 15);
            } else {
                // Se for novo, tenta pegar a posição do usuário
                this.geolocalizarUsuario();
            }

            setTimeout(() => {
                if(this.map) this.map.invalidateSize();
            }, 400);
        },

        // Criado um método separado para organizar melhor
        geolocalizarUsuario() {
            if ("geolocation" in navigator) {
                navigator.geolocation.getCurrentPosition((position) => {
                    const lat = position.coords.latitude;
                    const lng = position.coords.longitude;
                    if (this.map) {
                        this.map.setView([lat, lng], 15);
                        // Opcional: define as coordenadas iniciais mas não desenha o círculo até o clique
                        this.vlat = lat;
                        this.vlng = lng;
                        this.desenharZona();
                    }
                }, null, { enableHighAccuracy: false, timeout: 5000 });
            }
        },
        
        // mtdinitMap() {

          
        //     if (this.map) {
        //         // Se o mapa já existe, apenas limpa as camadas para um novo desenho
        //         if (this.circle) this.map.removeLayer(this.circle);
        //         if (this.marker) this.map.removeLayer(this.marker);
        //         if (this.edgeMarker) this.map.removeLayer(this.edgeMarker);
        //     } else {
        //         // Inicializa o mapa
        //         this.map = L.map('map').setView([-23.5505, -46.6333], 13); // Default SP (fallback)

        //         L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        //             attribution: '© OpenStreetMap'
        //         }).addTo(this.map);

        //         this.map.on('click', (e) => {
        //             if (this.ativadesativa) return;
        //             this.vlat = e.latlng.lat;
        //             this.vlng = e.latlng.lng;
        //             this.desenharZona();
        //         });
        //     }

        //     // --- LÓGICA DE LOCALIZAÇÃO APROXIMADA ---
        //     if (this.vlat && this.vlng) {
        //         // Se já tem dados salvos (edição), foca neles
        //         this.desenharZona();
        //         this.map.setView([this.vlat, this.vlng], 15);
        //     } else {
              
        //         if ("geolocation" in navigator) {
        //             navigator.geolocation.getCurrentPosition(
        //                 (position) => {
        //                     const lat = position.coords.latitude;
        //                     const lng = position.coords.longitude;
        //                     this.map.setView([lat, lng], 15);
                            
        //                     // Opcional: Já marcar o ponto inicial onde o usuário está
        //                     this.vlat = lat;
        //                     this.vlng = lng;
        //                     this.desenharZona();
        //                 },
        //                 (error) => {
        //                     console.warn("Não foi possível obter a localização: ", error.message);
        //                     // O mapa continuará no centro padrão (SP) definido no setView acima
        //                 },
        //                 {
        //                     enableHighAccuracy: false, // Define como false para usar rede/IP (mais rápido, menos bateria)
        //                     timeout: 5000,
        //                     maximumAge: Infinity
        //                 }
        //             );
        //         }
        //     }

        //     setTimeout(() => {
        //         this.map.invalidateSize();
        //     }, 400);
        // },

       desenharZona() {
            if (!this.map || !this.vlat || !this.vlng) return;

            // Remove camadas antigas com segurança
            if (this.circle) this.map.removeLayer(this.circle);
            if (this.marker) this.map.removeLayer(this.marker);
            if (this.edgeMarker) this.map.removeLayer(this.edgeMarker);

            const center = [parseFloat(this.vlat), parseFloat(this.vlng)];

            // 1. Círculo principal
            this.circle = L.circle(center, {
                color: 'blue',
                fillColor: '#30f',
                fillOpacity: 0.3,
                radius: parseFloat(this.vraio)
            }).addTo(this.map);

            // 2. Marcador do Centro
            this.marker = L.marker(center, { draggable: !this.ativadesativa }).addTo(this.map);
            
            this.marker.on('drag', (e) => {
                const newPos = e.target.getLatLng();
                this.vlat = newPos.lat;
                this.vlng = newPos.lng;
                this.circle.setLatLng(newPos);
                this.atualizarPosicaoMarcadorBorda();
            });

            // 3. Marcador de Borda (Handle)
            const edgePoint = this.calcularPontoBorda(center, this.vraio);
            
            this.edgeMarker = L.marker(edgePoint, {
                draggable: !this.ativadesativa,
                icon: L.divIcon({
                    className: 'custom-edge-handle',
                    html: '<div style="background-color: white; border: 2px solid blue; border-radius: 50%; width: 14px; height: 14px; box-shadow: 0 0 4px rgba(0,0,0,0.3);"></div>',
                    iconSize: [14, 14],
                    iconAnchor: [7, 7]
                })
            }).addTo(this.map);

            this.edgeMarker.on('drag', (e) => {
                const newEdgePos = e.target.getLatLng();
                const centerPos = this.marker.getLatLng();
                const novoRaio = centerPos.distanceTo(newEdgePos);
                
                this.vraio = Math.round(novoRaio);
                this.circle.setRadius(this.vraio);
            });
        },

        // Mantenha as funções auxiliares que passei antes:
        calcularPontoBorda(center, raioMetros) {
            const ponto = L.latLng(center);
            const offsetLng = (raioMetros / (111320 * Math.cos(ponto.lat * (Math.PI / 180))));
            return [ponto.lat, ponto.lng + offsetLng];
        },

        atualizarPosicaoMarcadorBorda() {
            if (this.edgeMarker) {
                const novoPonto = this.calcularPontoBorda([this.vlat, this.vlng], this.vraio);
                this.edgeMarker.setLatLng(novoPonto);
            }
        },

        atualizarMapaPorInput() {
            if (this.vlat && this.vlng) this.desenharZona();
        },
        mtdfiltropesquisa() {
            let rfiltro = '';
            if (parseInt(this.pfiltro) === 0) {
                rfiltro = this.pconteudo === '' ? '' : JSON.stringify({ campo: 'id', valor: this.pconteudo });
            } else {
                rfiltro = this.pconteudo === '' ? '' : JSON.stringify({ campo: 'nome', valor: this.pconteudo });
            }
            return rfiltro;
        },
        mtdexecutapesquisa() {
            var vself = this;
            let filtro = vself.mtdfiltropesquisa();
            this.pagina_atual = 1;
            let parametros = [
                { parametro: 'idusuario', valor: vself.$store.state.usuario.idusuario },
                { parametro: 'op',        valor: 'qtdregistros' },
                { parametro: 'idempresa', valor: vself.$store.state.usuario.idempresa },
                { parametro: 'filtro',    valor: filtro }
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/zonas.php');
            retorno.then(function (response) {
                vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                let qtdpg = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                vself.pqtd_paginas = qtdpg > 0 ? qtdpg : 1;
                vself.mtdcarregaitem(1);
            }).catch(function (response) {
                //alert('Erro ao consultar registros');
            });
        },
        mtdcarregaitem(ipagina) {
            let vself  = this;
            let filtro = vself.mtdfiltropesquisa();
            vself.$loading.show();
            let parametros = [
                { parametro: 'op',        valor: 'listagem' },
                { parametro: 'idusuario', valor: vself.$store.state.usuario.idusuario },
                { parametro: 'idempresa', valor: vself.$store.state.usuario.idempresa },
                { parametro: 'filtro',    valor: filtro },
                { parametro: 'limit',     valor: vself.pqtdregistros },
                { parametro: 'offset',    valor: (parseInt(ipagina) - 1) * parseInt(vself.pqtdregistros) },
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/zonas.php');
            retorno.then(function (response) {
                vself.lstzonas = JSON.parse(JSON.stringify(response.data));
                vself.$loading.hide();
            }).catch(function (response) {
                vself.lstzonas = [];
                vself.$loading.hide();
            });
        },
        mtdpreparacrud(op) {
            this.opcrud = op;
        },
        resetarDados() {
            this.vid        = '';
            this.vdescricao = '';
            this.vlat       = '';
            this.vlng       = '';
            this.vraio      = 500;
        },
        mtddefault() {
            $('#pnlista').hide();
            this.resetarDados();
            $('#pncadastro').fadeIn(700);
            this.$nextTick(function () {
                if (parseInt(this.opcrud) < 3) {
                    $('#eddescricao').focus();
                } else {
                    $('#btgravar').focus();
                }
            });
        },
        mtdpreparacrud(op) {
            this.opcrud = op;
            this.mtddefault();
        },
        mtdnovo() {
            this.descop = 'INCLUSÃO'
            this.ativadesativa = false;
            this.mtdpreparacrud(1);
            this.mtdinitMap();
        },
        mtdcancelaredicao() {
            this.descop = ''
            this.opcrud = 0;
            $('#pncadastro').hide();
            $('#pnlista').fadeIn(700);
            $('#edconteudopesq').focus();
        },
        mtdgravar() {
            let vself = this;
            Swal.fire({
                title: "Confirmação",
                text: 'Confirma ' + vself.descop + ' DE ' + vself.modulo + '?',
                icon: "warning",
                customClass: {
                    confirmButton: "conf btn btn-success",
                    cancelButton: "btn btn-danger"
                },
                showCancelButton: true,
                confirmButtonColor: "black",
                cancelButtonText: "Não",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sim"
            }).then((result) => {
                if (result.isConfirmed) {
                    $('.conf').prop('disabled', true);
                    vself.mtdregistro();
                } else {
                    $('#btgravar').focus();
                }
            });
        },
        mtdlocalizaregistro(id) {
            var vself = this;
            let filtro = JSON.stringify({ campo: 'id', valor: id });
            let parametros = [
                { parametro: 'op',        valor: 'listagem' },
                { parametro: 'idusuario', valor: vself.$store.state.usuario.idusuario },
                { parametro: 'idempresa', valor: vself.$store.state.usuario.idempresa },
                { parametro: 'filtro',    valor: filtro },
                { parametro: 'limit',     valor: 1 },
                { parametro: 'offset',    valor: 0 },
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/zonas.php');
            retorno.then(function (response) {
                vself.mtdigualarcampos(response.data[0]);
                if (parseInt(vself.opcrud) < 3) {
                    $('#eddescricao').focus();
                } else {
                    $('#btgravar').focus();
                }
            }).catch(function (response) {

            });
        },
        mtdalterar(id) {
            this.descop = 'ALTERAÇÃO'
            this.ativadesativa = false;
            this.mtdpreparacrud(2);
            this.mtdlocalizaregistro(id);
        },
        mtdexcluir(id) {
            this.descop = 'EXCLUSÃO'
            this.ativadesativa = true;
            this.mtdpreparacrud(3);
            this.mtdlocalizaregistro(id);
        },
        mtdigualarcampos(registro) {
            this.vid        = registro.id
            this.vdescricao = registro.nome;
            this.vlat       = registro.lat;
            this.vlng       = registro.lng;
            this.vraio      = registro.raio;
            this.mtdinitMap(); 
        },
        mtdregistro() {
            let vself = this;
            let registrocrud = {
                'id'     : this.vid,
                'nome'   : this.vdescricao,
                'lat'    : this.vlat,
                'lng'    : this.vlng,
                'raio'   : this.vraio,
            };
            let parametros = [
                { parametro: 'op',        valor: 'rotinacrud' },
                { parametro: 'opcrud',    valor: vself.opcrud },
                { parametro: 'idempresa', valor: vself.$store.state.usuario.idempresa },
                { parametro: 'registro',  valor: JSON.stringify(registrocrud) },
                { parametro: 'idusuario', valor: vself.$store.state.usuario.idusuario },
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/zonas.php');
            retorno.then(function (response) {
                if ($.isNumeric(response.data)) {
                    util.notif('success', 'Informação!', 'Registro processado com sucesso!');
                    vself.pfiltro = 0;
                    vself.pconteudo = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                    vself.pqtd_paginas = 1;
                    vself.mtdcancelaredicao();
                    vself.mtdcarregaitem(1);
                } else {
                    let tpret = response.data.substring(0, 1);
                    switch (tpret) {
                        case 'I':
                            util.notif('error', 'Informação!', response.data.substring(4));
                            break;
                        case 'E': default:
                            util.notif('error', 'Informação!', response.data.substring(4));
                            break;
                    }
                }
            }).catch(function (response) {
                alert('Erro ao processar o registo. Descrição do erro: ' + response.message)
            });
        },
    },
    computed: {
        validou() {
            return this.vdescricao == '' || this.vlat == '' || this.vraio <= 0;
        }
    },
    mounted() {
        $loading.show()
        setTimeout(() => {
            this.$loading.hide()
            this.mtdexecutapesquisa();
        }, 1000)
        $('#pncadastro').hide();
    },
    watch:{
        pagina_atual(val){
            this.mtdcarregaitem(val)
        }
    }
    
}
</script>

<style>
.cursor-resize {
    cursor: nwse-resize !important;
}
#map {
    cursor: crosshair;
}
</style>
